/**
 * Lead Capture CTA section — 3 fields (name, phone, email).
 * Higher-quality leads convert better than just email.
 */
import React from 'react';
import { User, Phone, Mail } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const EmailCaptureSection = ({ form, loading, onFieldChange, onSubmit }) => (
  <section className="section cta-section" id="email-capture" data-testid="email-capture-section">
    <div className="cta-content">
      <h2 className="cta-title">Deja de decir "mañana empiezo" y hazlo hoy</h2>
      <p className="cta-subtitle">
        Únete a miles que ya dejaron de ser víctimas de sus propios impulsos. El futuro tú te lo va a agradecer 🚀
      </p>
      <form onSubmit={onSubmit} className="cta-form" data-testid="email-capture-form">
        <div className="lead-field-group">
          <div className="lead-input-wrapper">
            <User className="lead-input-icon" />
            <Input
              type="text"
              autoComplete="name"
              placeholder="Nombre"
              value={form.name}
              onChange={onFieldChange('name')}
              className="lead-input"
              data-testid="email-capture-name"
              required
            />
          </div>
          <div className="lead-input-wrapper">
            <Phone className="lead-input-icon" />
            <Input
              type="tel"
              autoComplete="tel"
              inputMode="numeric"
              placeholder="Teléfono (10 dígitos)"
              value={form.phone}
              onChange={onFieldChange('phone')}
              className="lead-input"
              data-testid="email-capture-phone"
              required
            />
          </div>
          <div className="lead-input-wrapper">
            <Mail className="lead-input-icon" />
            <Input
              type="email"
              autoComplete="email"
              placeholder="tu@email.com"
              value={form.email}
              onChange={onFieldChange('email')}
              className="lead-input"
              data-testid="email-capture-input"
              required
            />
          </div>
        </div>
        <Button
          type="submit"
          size="lg"
          className="cta-submit"
          disabled={loading}
          data-testid="email-capture-submit"
        >
          {loading ? 'Enviando…' : 'Asesoría sin costo'}
        </Button>
        <p className="cta-privacy-hint">
          🔒 Tus datos están seguros. Sólo los usamos para que un asesor te contacte.
        </p>
      </form>
    </div>
  </section>
);

export default EmailCaptureSection;
